const requestIdleCallback =
  typeof window.requestIdleCallback === "function" ? window.requestIdleCallback : setTimeout;
const cancelIdleCallback =
  typeof window.cancelIdleCallback === "function" ? window.cancelIdleCallback : clearTimeout;
function debounce(fn, wait) {
  let timeout;
  function debounced(...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => fn.apply(this, args), wait);
  }
  debounced.cancel = () => {
    clearTimeout(timeout);
  };
  return (
    /** @type {T & { cancel(): void }} */
    debounced
  );
}
function onAnimationEnd(elements, callback, options = { subtree: true }) {
  const animations = Array.isArray(elements)
    ? elements.flatMap((element) => element.getAnimations(options))
    : elements.getAnimations(options);
  const animationPromises = animations.reduce(
    (acc, animation) => {
      if (animation.timeline instanceof DocumentTimeline) {
        acc.push(animation.finished);
      }
      return acc;
    },
    /** @type {Promise<Animation>[]} */
    []
  );
  return Promise.allSettled(animationPromises).then(callback);
}
const reducedMotion = matchMedia("(prefers-reduced-motion: reduce)");
function prefersReducedMotion() {
  return reducedMotion.matches;
}
function escapeHtml(text) {
  const div = document.createElement("div");
  div.textContent = text;
  return div.innerHTML;
}
function throttle(fn, ms) {
  let lastCall = 0;
  return function (...args) {
    const now = Date.now();
    if (now - lastCall >= ms) {
      lastCall = now;
      return fn.apply(this, args);
    }
  };
}
function formatMoney(cents, { locale = "de-DE", currency = "EUR" } = {}) {
  if (typeof cents !== "number" || isNaN(cents)) {
    return "";
  }
  const value = cents / 100;
  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
}
function defineCustomElement(name, constructor) {
  if (!customElements.get(name)) {
    customElements.define(name, constructor);
  }
}
function updateGalleryMedia(gallery, start, end) {
  const selectors = [
    ".carousel-slide[data-media-position]",
    ".carousel-thumbnail[data-media-position]",
    ".product-media-grid-item[data-media-position]",
  ];
  for (const selector of selectors) {
    const elements = Array.from(gallery.querySelectorAll(selector));
    elements.forEach((el) => {
      const pos = parseInt(el.dataset.mediaPosition, 10);
      if (Number.isNaN(pos)) {
        el.classList.remove("media-hidden");
        return;
      }
      el.classList.toggle("media-hidden", !(pos >= start && pos < end));
    });
    const extra = elements.find((el) => el.dataset.mediaPosition === "ablyft-media");
    if (extra) {
      const target = elements.find((el) => parseInt(el.dataset.mediaPosition, 10) === start);
      if (target && extra.previousElementSibling !== target) {
        target.insertAdjacentElement("afterend", extra);
      }
    }
  }
  const gridItems = Array.from(
    gallery.querySelectorAll(".product-media-grid-item[data-media-position]")
  );
  gridItems.forEach((item) => item.classList.remove("col-span-2"));
  const hero = gridItems.find((item) => {
    const pos = parseInt(item.dataset.mediaPosition, 10);
    return !Number.isNaN(pos) && !item.classList.contains("media-hidden");
  });
  if (hero) {
    hero.classList.add("col-span-2");
  }
  const embla = gallery.querySelector("carousel-embla");
  if (embla?.embla) {
    if (typeof embla.embla.reInit === "function") {
      embla.embla.reInit({ startSnap: 0 });
    }
    if (typeof embla.embla.goTo === "function") {
      embla.embla.goTo(0, true);
    }
  }
}
export {
  debounce as a,
  cancelIdleCallback as c,
  defineCustomElement as d,
  escapeHtml as e,
  formatMoney as f,
  onAnimationEnd as o,
  prefersReducedMotion as p,
  requestIdleCallback as r,
  throttle as t,
  updateGalleryMedia as u,
};
